import { render, staticRenderFns } from "./OrderItemOption.vue?vue&type=template&id=b8f526a0"
import script from "./OrderItemOption.vue?vue&type=script&lang=js"
export * from "./OrderItemOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports